class LoginScreenController {
  constructor(
      $scope,
      DataSyncService,
      APIService,
      API_URL,
      $location
  ) {
    "ngInject";
    this.$scope = $scope;
    this.Authentication
    this.DataSyncService = DataSyncService;
    this.APIService = APIService;
    this.API_URL = API_URL;
    this._errors = [];
    this._loading = false;
    this.$location = $location;
  }

  /**
   * Public properties
   */

  get errors() {
    return this._errors;
  }

  get loading() {
    return this._loading;
  }

  set username(username) {
    this._username = username;
  }

  get username() {
    return this._username;
  }

  set password(password) {
    this._password = password;
  }

  get password() {
    return this._password;
  }

  set onLogin(onLogin) {
    this._onLogin = onLogin;
  }

  get onLogin() {
    return this._onLogin;
  }

  get loginButtonDisabled() {
    return !this.APIService.isDeviceOnline;
  }

  get forgotPasswordButtonDisabled() {
    return !this.APIService.isDeviceOnline;
  }

  get forgotPasswordURL() {
    if (!this._forgotPasswordUrl) {
      const baseUrl = this.API_URL.replace(/\/api\/[^\/]+/, '');
      this._forgotPasswordUrl = `${baseUrl}/auth/staff_request_password_reset.php`;
    }
    return this._forgotPasswordUrl;
  }

  /**
   * Public methods
   */

  login() {
    this._clearErrors();
    this._loading = true;

    // Ensure offline mode is not set
    if (this.APIService.isOfflineMode) {
      this.APIService.isOfflineMode = false;
    }

    return this.DataSyncService.loginAndSync(this.username, this.password)
      .then(staffUser => {
        // Login was successful!
        // Call our onLogin callback
        const callbackParams = {staffUser};
        this.onLogin(callbackParams);
      })
      .catch(err => {
        // Login was not successful!
        // Let's show an error message
        this._addError(err);
      })
      .finally(() => {
        // Regardless, mark loading as finished
        this._loading = false;
      });
  }

  /**
   * Private methods
   */

  _clearErrors() {
    this._errors.length = 0;
  }

  _addError(error) {
    this.errors.push(error);
  }
}

export default LoginScreenController;
